import axios from "axios";
var parseLinkHeader = require("parse-link-header");

const getVaults = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`vaults?page=${payload.page}`, {
        data: {},
      })
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("set_vaults", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "Vaults",
              collectionId: 1,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getVaultTransactions = (context, payload = { page: 1 }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`vault_transactions?page=${payload.page}`, {
        data: {},
      })
      .then(
        (response) => {
          if (response.status === 200) {
            context.commit("set_vault_transactions", {
              data: response.data.data,
              meta: response.data.meta,
              headerLinks: parseLinkHeader(response.headers.link),
              total: response.headers.total,
              perPage: response.headers["per-page"],
              context: "VaultTrans",
              collectionId: 1,
            });
          }
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const getVault = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`vaults/${payload.id}`, {
        data: {},
      })
      .then(
        (response) => {
          context.commit("set_vault", response.data.data);
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const addVault = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`vaults/`, {
        data: payload.data,
      })
      .then(
        (response) => {
          context.commit("set_vault", response.data.data);
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const updateVault = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(`vaults/${payload.id}`, {
        data: payload.params,
      })
      .then(
        (response) => {
          context.commit("set_vault", response.data.data);
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const deleteVault = (context, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`vaults/${payload.id}`, {
        data: {
          data: {},
        },
      })
      .then(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
  });
};

const serviceLogin = ({commit, dispatch},  data) => {
  return axios.post(`vaults/${data.id}/service-login`, {
    data: {
      email: data.email,
      password: data.password,
    }
  }).then( response => {
    commit("set_vault", response.data.data);
  }).catch( response => {
    // todo: popup an error box possibly
  })
}

const vaultLogin = (context, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: "post",
      url: data.api + "auth/login",
      params: {
        email: data.email,
        password: data.password,
      },
      headers: {
        "content-type": "application/vnd.api+json",
        accept: "application/vnd.api+json",
      },
    }).then(
      (response) => {
        if (response.data && response.data.auth_token) {
          // localStorage.token = response.data.auth_token
          context.commit("set_login_token", response.data.auth_token);
        }
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

const vaultRenewToken = (context, data) => {
  const proxy_route = 'vaults'
  return axios.post ([ proxy_route, data.vault_id , 'relayer'].join("/"), {
    data: {
      http_verb: 'post',
      api_route: 'auth/renew-token',
      data: {}
    }
  })

  // const tmp = new Date();
  // tmp.setYear(new Date().getFullYear() + 1);
  // const utc = tmp.toUTCString();

  // const auth_token = "Bearer " + data.auth_token;
  // const api_uri = data.api.endsWith("/") ? data.api : data.api + "/";
  // const url = api_uri + "api/v1/jwts";
  // const payload = {
  //   data: {
  //     type: "jwts",
  //     attributes: {
  //       expires_at: utc,
  //       user_id: data.user_id,
  //     },
  //   },
  // };

  // return new Promise((resolve, reject) => {
  //   axios({
  //     method: "post",
  //     url: api_uri + "api/v1/jwts",
  //     data: payload,
  //     headers: {
  //       "Content-Type": "application/json",
  //       accept: "application/vnd.api+json",
  //       Authorization: auth_token,
  //     },
  //   }).then(
  //     (response) => {
  //       if (
  //         response.data &&
  //         response.data.attributes &&
  //         response.data.attributes.token
  //       ) {
  //         // localStorage.token = response.data.auth_token
  //         context.commit("set_login_token", response.data.attributes.token);
  //       }
  //       resolve(response);
  //     },
  //     (error) => {
  //       reject(error);
  //     }
  //   );
  // });
};

export default {
  getVaults,
  getVaultTransactions,
  getVault,
  addVault,
  updateVault,
  deleteVault,
  vaultLogin,
  vaultRenewToken,

  serviceLogin,
};



// WEBPACK FOOTER //
// ./src/modules/systemStates/store/actions.js